import axios from "axios";
import { Endpoints } from "../endpoints";
import { STORAGE_TOKEN_KEY } from "../../contexts/AuthContext";
import { NonPaginatedResponse } from "../../types";
import { IFileProps } from "../../types/File";

export interface UploadFilesOptions {
  fieldName?: string; // form field name to use for files (default: 'files')
  extraData?: Record<string, string | Blob>; // additional form fields
  signal?: AbortSignal; // optional abort controller signal
}

export async function uploadFiles(
  files: File[],
  options?: UploadFilesOptions
): Promise<IFileProps[]> {
  try {
    const formData = new FormData();

    const fieldName = options?.fieldName || "files";
    files.forEach((file) => {
      if (file) {
        formData.append(fieldName, file);
      }
    });

    if (options?.extraData) {
      Object.entries(options.extraData).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    const { route, method } = Endpoints.GetUploadFile();
    const token = typeof window !== "undefined" ? localStorage.getItem(STORAGE_TOKEN_KEY) : null;

    const response = await axios.request<NonPaginatedResponse<IFileProps[]>>({
      url: route,
      method,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      signal: options?.signal,
    });

    return response.data.data;
  } catch (err) {
    // Re-throw to let caller handle notifications/UI
    throw err;
  }
}

export default uploadFiles;